import { logoutApi } from "@/api/services/admin/auth";
import { getTokens, removeToken } from "@/utils/token";
import Cookies from "js-cookie";

/**
 * Clears the local session: removes tokens (and the Axios auth header via
 * removeToken) and any user-metadata cookies set at login.
 *
 * Lives in its own module so both `@/utils/api` (refresh-failure path) and
 * `@/utils/error` (permission-denied path) can call it without creating a
 * circular import through the axios instance module.
 *
 * Returns the email of the session being cleared (read before the cookie is
 * removed) so callers can send the user back to `/login?email=...` and keep the
 * login form pre-filled.
 */
export const logout = async (): Promise<string | undefined> => {
  const { refreshToken } = getTokens();
  if (refreshToken) {
    await logoutApi({ refreshToken }).catch(() => {
      //do nothing
    });
  }
  const email = Cookies.get("admin-email");
  removeToken();
  Cookies.remove("admin-email");
  return email;
};
